export default __webpack_public_path__ + "static/media/brain.f5e8766b.png";